// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zqak","right":"styles_right__2VGIy"};